"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var backarrow_1 = __importDefault(require("./backarrow"));
var cancel_1 = __importDefault(require("./cancel"));
var country_1 = __importDefault(require("./country"));
var delete_1 = __importDefault(require("./delete"));
var download_1 = __importDefault(require("./download"));
var edit_1 = __importDefault(require("./edit"));
var education_report_1 = __importDefault(require("./education-report"));
var expand_1 = __importDefault(require("./expand"));
var eyeclose_1 = __importDefault(require("./eyeclose"));
var eyeopen_1 = __importDefault(require("./eyeopen"));
var acorn_app_1 = __importDefault(require("./acorn-app"));
var key_1 = __importDefault(require("./key"));
var language_1 = __importDefault(require("./language"));
var logo_1 = __importDefault(require("./logo"));
var logoff_1 = __importDefault(require("./logoff"));
var nuttitionIcon_1 = __importDefault(require("./nuttitionIcon"));
var organization_1 = __importDefault(require("./organization"));
var plus_1 = __importDefault(require("./plus"));
var remove_1 = __importDefault(require("./remove"));
var report_1 = __importDefault(require("./report"));
var save_1 = __importDefault(require("./save"));
var service_1 = __importDefault(require("./service"));
var setting_1 = __importDefault(require("./setting"));
var tick_1 = __importDefault(require("./tick"));
var tool_1 = __importDefault(require("./tool"));
var sensitation_1 = __importDefault(require("./sensitation"));
var user_1 = __importDefault(require("./user"));
var widget_1 = __importDefault(require("./widget"));
var zip_1 = __importDefault(require("./zip"));
var knowledge_1 = __importDefault(require("./knowledge"));
var participant_1 = __importDefault(require("./participant"));
var area_mapping_1 = __importDefault(require("./area-mapping"));
var knowledge_report_1 = __importDefault(require("./knowledge-report"));
var sensitation_report_1 = __importDefault(require("./sensitation-report"));
var Icon = [
    {
        name: 'education_report',
        icon: education_report_1.default,
    },
    {
        name: 'report',
        icon: report_1.default,
    },
    {
        name: 'setting',
        icon: setting_1.default,
    },
    {
        name: 'tool',
        icon: tool_1.default,
    },
    {
        name: 'remove',
        icon: remove_1.default,
    },
    {
        name: 'delete',
        icon: delete_1.default,
    },
    {
        name: 'language',
        icon: language_1.default,
    },
    {
        name: 'user',
        icon: user_1.default,
    },
    {
        name: 'key',
        icon: key_1.default,
    },
    {
        name: 'eyeClose',
        icon: eyeclose_1.default,
    },
    {
        name: 'eyeOpen',
        icon: eyeopen_1.default,
    },
    {
        name: 'backArrow',
        icon: backarrow_1.default,
    },
    {
        name: 'logo',
        icon: logo_1.default,
    },
    {
        name: 'logOut',
        icon: logoff_1.default,
    },
    {
        name: 'AcornAppIcon',
        icon: acorn_app_1.default,
    },
    {
        name: 'widgetIcon',
        icon: widget_1.default,
    },
    {
        name: 'knowledge',
        icon: knowledge_1.default,
    },
    {
        name: 'service',
        icon: service_1.default,
    },
    {
        name: 'sensitation',
        icon: sensitation_1.default,
    },
    {
        name: 'save',
        icon: save_1.default,
    },
    {
        name: 'plus',
        icon: plus_1.default,
    },
    {
        name: 'tick',
        icon: tick_1.default,
    },
    {
        name: 'cancel',
        icon: cancel_1.default,
    },
    {
        name: 'edit',
        icon: edit_1.default,
    },
    {
        name: 'NutriCoach',
        icon: nuttitionIcon_1.default,
    },
    {
        name: 'expand',
        icon: expand_1.default,
    },
    {
        name: 'zip',
        icon: zip_1.default,
    },
    {
        name: 'download',
        icon: download_1.default,
    },
    {
        name: 'organization',
        icon: organization_1.default,
    },
    {
        name: 'country',
        icon: country_1.default,
    },
    {
        name: 'area_mapping',
        icon: area_mapping_1.default,
    },
    {
        name: 'participant',
        icon: participant_1.default,
    },
    {
        name: 'knowledge_report',
        icon: knowledge_report_1.default,
    },
    {
        name: 'sensitation_report',
        icon: sensitation_report_1.default,
    },
];
exports.default = Icon;
